export const strokeDash3Icon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 9v2h5V9zm6 0v2h2V9zm3 0v2h5V9zm6 0v2h2V9z"/></svg>`,
  name: 'stroke-dash-3',
};
